// EditQuestion.jsx
import { useEffect, useState, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Switch,
  FormControlLabel,
  MenuItem,
  IconButton,
  Pagination,
  Paper,
  InputLabel,
  CircularProgress,
  Tooltip,
  Skeleton,
  Checkbox,
  ListItemText
} from "@mui/material";
import { Add, Delete } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import adminLoginBg from "../../assets/images/background.png";
import { useApi } from "../../api/useApi";
import Notification from "../Notification";
import { validateQuestion } from "./addnewquestionaire";
import BackButton from "../BackButton";

function OverflowTooltipTextField({ value, onChange, ...props }) {
  const inputRef = useRef(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  useEffect(() => {
    if (inputRef.current) {
      setIsOverflowing(inputRef.current.scrollWidth > inputRef.current.clientWidth);
    }
  }, [value]);

  return (
    <Tooltip title={isOverflowing ? value : ""} placement="top-start" disableInteractive>
      <TextField
        {...props}
        value={value}
        onChange={onChange}
        inputRef={inputRef}
        InputProps={{
          ...props.InputProps,
          sx: {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            ...(props.InputProps?.sx || {}),
          },
        }}
      />
    </Tooltip>
  );
}

export default function EditQuestion() {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const domain = location.pathname.split("/")[2];
  const questions = location.state?.questions || [];
  const [allQuestions, setAllQuestions] = useState([]);
  const { request, loading, error } = useApi();
  const [roles, setRoles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [userDomain, setUserDomain] = useState([]);
  const [notif, setNotif] = useState({
    open: false,
    success: true,
    text: "",
  });
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchQuestions = async () => {
      try {
        const data = await request({ url: "/questions/all" });
        setAllQuestions(data);
        let rolesSet = new Set();
        let categoriesSet = new Set();
        const userDomainSet = new Set();
        for (const q of data) {
          rolesSet.add(q.userRole);
          categoriesSet.add(q.category);
          userDomainSet.add(q.userDomainRole);
        }
        const uniqueCategories = [
          ...new Set(
            [...userDomainSet]
              .filter(Boolean)
              .flatMap((item) => item.split("/"))
              .map((item) => item.trim())
          ),
        ];
        setRoles([...rolesSet]);
        setCategories([...categoriesSet]);
        setUserDomain([...uniqueCategories]);
      } catch (err) {
        console.error("Failed to load questions", err);
      }
    };
    fetchQuestions();
  }, []);

  useEffect(() => {
    const dataToUse = questions && questions.length > 0 ? questions : allQuestions;
    const formatted = dataToUse.map((q) => {
      const optionTexts = q.optionText?.split(",") || [];
      const optionPoints = q.optionPoints?.split(",") || [];
      const recommendations = q.recommendation?.split("||") || [];
      const remarks = q.remarks?.split(",") || [];

      const options = optionTexts.map((text, idx) => ({
        optionText: text,
        optionPoints: parseFloat(optionPoints[idx] || 0),
        recommendationText: recommendations[idx] || "",
        remarkText: remarks[idx] || "",
      }));

      console.log('all display data', questions)

      return {
        ...q,
        options,
        questionIsMandatory: q.questionIsMandatory || false,
        isWeightage: Boolean(optionPoints.length),
        userRole: q.userRole || "",
        category: q.category || "",
        userDomainRole: q.userDomainRole || ""
      };
    });

    setData(formatted);
  }, [location.state?.questions, allQuestions]);

  const currentQuestion = data[currentPage - 1];

  // isLoading will be true when api loading or data not yet present
  const isLoading = loading || data.length === 0 || !currentQuestion;

  const handleOptionChange = (index, field, value) => {
    const updated = [...data];
    if (!updated[currentPage - 1]) return;
    updated[currentPage - 1].options[index][field] = value;
    setData(updated);
  };

  const addOption = () => {
    const updated = [...data];
    if (!updated[currentPage - 1]) return;
    updated[currentPage - 1].options.push({
      optionText: "",
      optionPoints: 0,
      recommendationText: "",
    });
    setData(updated);
  };

  const deleteOption = (index) => {
    const updated = [...data];
    if (!updated[currentPage - 1]) return;
    if (updated[currentPage - 1].options.length === 1) {
      setNotif({
        open: true,
        success: false,
        text: "Oops! The Option and its weight percentage are mandatory",
      });
      return;
    }
    updated[currentPage - 1].options.splice(index, 1);
    setData(updated);
  };

  // const handleSave = async () => {
  //   try {
  //     console.log('complete data', data)
  //     const payload = data.map((q) => ({
  //       questionId: q.questionId, // required for update
  //       questionText: q.question, // API expects "questions" key, not "question"
  //       userRole: q.userRole,
  //       domain: domain.toUpperCase(), // from route
  //       userDomainRoles: q.userDomainRole,
  //       category: q.category,
  //       questionIsMandatory: q.questionIsMandatory,
  //       options: q.options.map((o) => ({
  //         optionText: o.optionText,
  //         optionPoints: (o.optionPoints).toString(),
  //         recommendationText: o.recommendationText || "",
  //         remarks: o.remarkText || "", // include if backend supports remarks
  //       })),
  //     }));
  //   for (let i = 0; i < payload.length; i++) {
  //     const error = validateQuestion(payload[i]);
  //     if (error) {
  //       setNotif({ open: true, success: false, text: `Question ${i + 1}: ${error}` });
  //       return;
  //     }
  //   }
  //     await request({ url: `/questions/${data[0].questionId}`, method: "PUT", data: payload });
  //     setNotif({
  //       open: true,
  //       success: true,
  //       text: "Question(s) update successful",
  //     });
  //     setData(payload);
  //     setTimeout(() => {
  //       navigate(
  //         `/admin/${domain}/questionaire`
  //       );
  //     }, 1000);
  //   } catch (err) {
  //     console.error(err);
  //     setNotif({
  //       open: true,
  //       success: false,
  //       text: "Question(s) update failed",
  //     });
  //     setSuccess(false);
  //   }
  // };
const handleSave = async () => {
  const payload = data.map((q) => ({
    questionId: q.questionId,
    questionText: q.question,
    userRole: q.userRole,
    domain: domain.toUpperCase(),
    // Fix 1: split string into array instead of passing raw string
    userDomainRoles: q.userDomainRole
      ? q.userDomainRole.split("/").map((r) => r.trim()).filter(Boolean)
      : [],
    category: q.category,
    questionIsMandatory: q.questionIsMandatory,
    options: q.options.map((o) => ({
      optionText: o.optionText,
      optionPoints: (o.optionPoints).toString(),
      recommendationText: o.recommendationText || "",
      remarks: o.remarkText || "",
    })),
  }));

  for (let i = 0; i < payload.length; i++) {
    const error = validateQuestion(payload[i]);
    if (error) {
      setNotif({ open: true, success: false, text: `Question ${i + 1}: ${error}` });
      return;
    }
  }

  // Fix 2 & 3: call PUT /questions/{id} individually for each question
  for (const q of payload) {
    await request({ url: `/questions/${q.questionId}`, method: "PUT", data: q });
  }

  setNotif({ open: true, success: true, text: "Question(s) update successful" });
  setTimeout(() => navigate(`/admin/${domain}/questionaire`), 1000);
};
  const optionTextValues = [
    ...new Set(
      currentQuestion?.options?.map(o => o.optionText).filter(Boolean)
    )
  ];

  const optionPointValues = [
    ...new Set(
      currentQuestion?.options?.map(o => o.optionPoints)
        .filter(v => v !== undefined && v !== null)
    )
  ];

  const remarkValues = [
    ...new Set(
      currentQuestion?.options?.map(o => o.remarkText).filter(Boolean)
    )
  ];

  return (
    <>
      <Box
        sx={{
          minHeight: "90vh",
          position: "relative",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          p: 2,
        }}
      >
        {/* Background layers */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // backgroundImage: `url(${adminLoginBg})`,
            // backgroundSize: "cover",
            // backgroundPosition: "center",
            opacity: 0.2,
            zIndex: -1,
          }}
        />
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            // background: "conic-gradient(from -7.72deg at 100% 100%, #000000 0deg, #49454F 294.45deg, #000000 360deg)",
            // opacity: 1,
            // backdropFilter: "blur(20px) saturate(180%)",
            // WebkitBackdropFilter: "blur(12px) saturate(180%)",
            // zIndex: -2,
          }}
        />

        {/* Main Paper */}
        <Paper
            elevation={6}
            sx={{
            display: "flex",
            maxWidth: "77vw",
            width: "77vw",
            minHeight: { xs: "90vh", sm: "80vh", md: "85vh" },
            borderRadius: 4,
            overflow: "hidden",
            // background: "rgba(255,255,255,0.15)",
            // backdropFilter: "blur(5px)",
            flexDirection: "column",
            p: 2,
            flex: 1,
            }}
        >
          <Typography variant="h5" sx={{ ml: 2, mb: 2 }}>

            Edit Questionaire:<span style={{ fontWeight: "bold" }}>{domain.toLocaleUpperCase()}</span>
          </Typography>
          <Box
            sx={{
              mb: 1,
              p: 2,
              borderRadius: 5,
              //backgroundColor: "rgba(255,255,255,0.7)",
            }}
          >
            {/* Header */}
            <Typography
              variant="subtitle1"
              fontWeight="bold"
              gutterBottom
              sx={{
                mb: 2,
                borderRadius: 2,
                p: 1,
                pl: 2,
              }}
            >
              {isLoading ? <Skeleton variant="text" width={200} /> : `Question: ${currentPage}/${data.length}`}
            </Typography>

            <fieldset disabled={isLoading} style={{ border: "none" }}>
              {/* Switches */}
              <Box display="flex" gap={4} mt={2}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!currentQuestion?.questionIsMandatory}
                      onChange={(e) => {
                        const updated = [...data];
                        if (!updated[currentPage - 1]) return;
                        updated[currentPage - 1].questionIsMandatory = e.target.checked;
                        setData(updated);
                      }}
                    />
                  }
                  label="Is this question mandatory?"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={!!currentQuestion?.isWeightage}
                      onChange={(e) => {
                        const updated = [...data];
                        if (!updated[currentPage - 1]) return;
                        updated[currentPage - 1].isWeightage = e.target.checked;
                        setData(updated);
                      }}
                    />
                  }
                  label="Is there a weightage for this question?"
                />
              </Box>

              {/* Role + Category */}
              <Box display="flex" gap={2} mt={2}>
                {/* Role Dropdown */}
                <Box display="flex" flexDirection="column" flex={1}>
                  <InputLabel sx={{ mb: 1, ml: 1, color: "black", fontWeight: "normal" }} required>
                    Select Role
                  </InputLabel>
                  {isLoading ? (
                    <Skeleton variant="rounded" height={56} />
                  ) : (
                    <TextField
                      select
                      fullWidth
                      value={currentQuestion?.userRole || ""}
                      onChange={(e) => {
                        const updated = [...data];
                        updated[currentPage - 1].userRole = e.target.value;
                        setData(updated);
                      }}
                      variant="outlined"
                      sx={{
                        borderRadius: "24px",
                        backgroundColor: "whitesmoke",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "24px",
                        },
                      }}
                    >
                      {roles?.map((role) => (
                        <MenuItem key={role} value={role}>
                          {role}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Box>

                {/* Category Dropdown */}
                <Box display="flex" flexDirection="column" flex={1}>
                  <InputLabel sx={{ mb: 1, ml: 1, color: "black" }} required>
                    Category
                  </InputLabel>
                  {isLoading ? (
                    <Skeleton variant="rounded" height={56} />
                  ) : (
                    <TextField
                      select
                      fullWidth
                      value={currentQuestion?.category || ""}
                      onChange={(e) => {
                        const updated = [...data];
                        updated[currentPage - 1].category = e.target.value;
                        setData(updated);
                      }}
                      variant="outlined"
                      sx={{
                        borderRadius: "24px",
                        backgroundColor: "whitesmoke",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "24px",
                        },
                      }}
                    >
                      {categories?.map((cat) => (
                        <MenuItem sx={{ borderRadius: "40px" }} key={cat} value={cat}>
                          {cat}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Box>

                {/* Domain Role Dropdown */}
                <Box display="flex" flexDirection="column" flex={1}>
                  <InputLabel sx={{ mb: 1, ml: 1, color: "black" }} required>
                    Domain Role
                  </InputLabel>
                  {isLoading ? (
                    <Skeleton variant="rounded" height={56} />
                  ) : (
                    <TextField
                      select
                      fullWidth
                      SelectProps={{
                        multiple: true,
                        renderValue: (selected) => selected.join(", "),
                      }}
                      sx={{
                        borderRadius: "24px",
                        backgroundColor: "whitesmoke",
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderRadius: "24px",
                        },
                      }}
                      value={
                        currentQuestion?.userDomainRole
                          ? currentQuestion.userDomainRole.split("/")
                          : []
                      }
                      onChange={(e) => {
                        const updated = [...data];

                        updated[currentPage - 1].userDomainRole =
                          e.target.value.join("/");

                        setData(updated);
                      }}
                    >
                      {userDomain?.map((cat) => (
                        <MenuItem key={cat} value={cat}>
                          <Checkbox
                            checked={
                              currentQuestion?.userDomainRole
                                ?.split("/")
                                ?.includes(cat)
                            }
                          />
                          <ListItemText primary={cat} />
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                </Box>

                {/* Type Dropdown */}
                <Box display="flex" flexDirection="column" flex={1}>
                  <InputLabel sx={{ mb: 1, ml: 1, color: "black" }}>Domain</InputLabel>
                  {isLoading ? (
                    <Skeleton variant="rounded" height={56} />
                  ) : (
                    <TextField
                      fullWidth
                      disabled
                      value={domain.toLocaleUpperCase()}
                      onChange={(e) => {
                        const updated = [...data];
                        if (!updated[currentPage - 1]) return;
                        updated[currentPage - 1].type = e.target.value;
                        setData(updated);
                      }}
                      slotProps={{
                        htmlInput: {
                          readOnly: true,
                        },
                      }}
                      variant="outlined"
                      sx={{
                        borderRadius: "24px",
                        backgroundColor: "whitesmoke",
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "24px",
                        },
                      }}
                    />
                  )}
                </Box>
              </Box>

              {/* Question Text */}
              <Box display="flex" flexDirection="column" mt={2}>
                {/* Label with required mark */}
                <InputLabel sx={{ mb: 1, ml: 1, color: "black" }}>Enter your question</InputLabel>

                {/* Multiline TextField */}
                {isLoading ? (
                  <Skeleton variant="rounded" height={120} />
                ) : (
                  <TextField
                    fullWidth
                    required
                    multiline
                    rows={4} // adjust for height
                    value={currentQuestion?.question || ""}
                    onChange={(e) => {
                      const updated = [...data];
                      updated[currentPage - 1].question = e.target.value;
                      setData(updated);
                    }}
                    variant="outlined"
                    sx={{
                      borderRadius: "16px",
                      backgroundColor: "whitesmoke",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "16px",
                      },
                    }}
                  />
                )}
              </Box>

              {/* Options */}
              
              {currentQuestion?.options?.map((opt, index) => (
              <Box
                key={index}
                display="flex"
                gap={2}
                alignItems="flex-start"
                mt={2}
              >
                {/* Option Text */}
                <Box display="flex" flexDirection="column" flex={0.8}>
                  <InputLabel
                    sx={{ mb: 1, ml: 1, color: "black" }}
                    required
                  >
                    Enter option
                  </InputLabel>

                  <OverflowTooltipTextField
                    select
                    value={opt.optionText || ""}
                    onChange={(e) =>
                      handleOptionChange(
                        index,
                        "optionText",
                        e.target.value
                      )
                    }
                    variant="outlined"
                    fullWidth
                    sx={{
                      backgroundColor: "whitesmoke",
                      borderRadius: "24px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "24px",
                      },
                    }}
                  >
                    {optionTextValues.map((value) => (
                      <MenuItem
                        key={value}
                        value={value}
                      >
                        {value}
                      </MenuItem>
                    ))}
                  </OverflowTooltipTextField>
                </Box>


                {/* Weight */}
                <Box display="flex" flexDirection="column" flex={0.6}>
                  <InputLabel
                    sx={{ mb: 1, ml: 1, color: "black" }}
                  >
                    Weight percentage
                  </InputLabel>

                  <OverflowTooltipTextField
                    select
                    value={opt.optionPoints ?? ""}
                    onChange={(e) =>
                      handleOptionChange(
                        index,
                        "optionPoints",
                        Number(e.target.value)
                      )
                    }
                    variant="outlined"
                    fullWidth
                    sx={{
                      backgroundColor: "whitesmoke",
                      borderRadius: "24px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "24px",
                      },
                    }}
                  >
                    {optionPointValues.map((value) => (
                      <MenuItem
                        key={value}
                        value={value}
                      >
                        {value}
                      </MenuItem>
                    ))}
                  </OverflowTooltipTextField>
                </Box>


                {/* Recommendation */}
                <Box display="flex" flexDirection="column" flex={2}>
                  <InputLabel
                    sx={{ mb: 1, ml: 1, color: "black" }}
                  >
                    Recommendation
                  </InputLabel>

                  <OverflowTooltipTextField
                    value={opt.recommendationText || ""}
                    onChange={(e) =>
                      handleOptionChange(
                        index,
                        "recommendationText",
                        e.target.value
                      )
                    }
                    variant="outlined"
                    fullWidth
                    sx={{
                      backgroundColor: "whitesmoke",
                      borderRadius: "24px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "24px",
                      },
                    }}
                  />
                </Box>


                {/* Remarks */}
                <Box display="flex" flexDirection="column" flex={1}>
                  <InputLabel
                    sx={{ mb: 1, ml: 1, color: "black" }}
                  >
                    Remarks
                  </InputLabel>

                  <OverflowTooltipTextField
                    select
                    value={opt.remarkText || ""}
                    onChange={(e) =>
                      handleOptionChange(
                        index,
                        "remarkText",
                        e.target.value
                      )
                    }
                    variant="outlined"
                    fullWidth
                    sx={{
                      backgroundColor: "whitesmoke",
                      borderRadius: "24px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "24px",
                      },
                    }}
                  >
                    {remarkValues.map((value) => (
                      <MenuItem
                        key={value}
                        value={value}
                      >
                        {value}
                      </MenuItem>
                    ))}
                  </OverflowTooltipTextField>
                </Box>

                {/* Delete Button */}
                <IconButton
                  onClick={() => deleteOption(index)}
                  color="error"
                  sx={{ mt: 4 }}
                >
                  <Delete />
                </IconButton>
              </Box>
               ))}
                {currentQuestion && (
                  <Button startIcon={<Add />} onClick={addOption} sx={{ mt: 2 }}>Add Option</Button>
                )}

              {/* Actions */}
              <Box display="flex" justifyContent="space-between" alignItems="center">
                <Box display="flex" justifyContent="flex-start" alignItems="center" gap={2} mt={4}>
                  <Button
                    sx={{ backgroundColor: "#ffffff", color: "#0036DD", px: 6, py: 1.5, borderRadius: "30px" }}
                    variant="contained"
                    onClick={() => navigate(`/admin/${domain}/questionaire`)}
                  >
                    Cancel
                  </Button>
                  {data.length > 1 && currentPage < data.length && (
                    <Button
                      onClick={() => setCurrentPage((prev) => Math.min(prev + 1, data.length))}
                      sx={{ backgroundColor: "#ffffff", color: "#0036DD", px: 6, py: 1.5, borderRadius: "30px" }}
                      variant="contained"
                    >
                      Next
                    </Button>
                  )}
                </Box>
                <Button
                  sx={{ backgroundColor: "#0036DD", color: "#ffffff", mt: 4, px: 6, py: 1.5, borderRadius: "30px" }}
                  variant="contained"
                  onClick={handleSave}
                  disabled={isLoading || loading}
                >
                  {loading ? <CircularProgress size={32} color="inherit" /> : "Save"}
                </Button>
              </Box>
            </fieldset>
          </Box>

          {/* Pagination */}
          {data.length > 1 && (
            <Box display="flex" justifyContent="center" mt={3}>
              <Pagination
                count={data.length}
                page={currentPage}
                onChange={(e, page) => setCurrentPage(page)}
                variant="text"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  "& .MuiPaginationItem-root": {
                    color: "black",
                    minWidth: "32px",
                    height: "32px",
                    fontWeight: 500,
                    transition: "all 0.3s ease",
                  },
                  "& .MuiPaginationItem-root:hover": {
                    color: "whitesmoke",
                  },
                  "& .MuiPaginationItem-root.Mui-selected": {
                    color: "black",
                    borderBottom: "2px solid whitesmoke",
                    borderRadius: 0,
                  },
                  "& .MuiPaginationItem-previousNext": {
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "black",
                    minWidth: "32px",
                    height: "32px",
                    transition: "all 0.3s ease",
                  },
                  "& .MuiPaginationItem-previousNext:hover": {
                    color: "whitesmoke",
                  },
                }}
                slots={{
                  previous: () => <span>{'<'}</span>,
                  next: () => <span>{'>'}</span>,
                }}
              />
            </Box>
          )}
        </Paper>
      </Box>
      <Notification
        open={notif.open}
        success={notif.success}
        text={notif.text}
        onClose={() => setNotif((prev) => ({ ...prev, open: false }))}
      />
    </>
  );
}